// ** React Imports
import { ReactNode } from 'react'

// ** MUI Imports
import { deepmerge } from '@mui/utils'
import { Theme } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import GlobalStyles from '@mui/material/GlobalStyles'
import { ThemeProvider, createTheme, responsiveFontSizes } from '@mui/material/styles'

// ** Theme Override Imports
import overrides from './overrides'
import typography from './typography'

// ** Theme
import AppThemeOptions from './AppThemeOptions'

// ** Global Styles
import GlobalStyling from './globalStyles'
import themeOptions from './ThemeOptions'

interface Props {
  children: ReactNode
}

const ThemeComponent = (props: Props) => {
  // ** Props
  const { children } = props

  // ** Pass ThemeOptions to CreateTheme Function to create partial theme without component overrides
  let theme = createTheme(themeOptions())
  theme = responsiveFontSizes(theme)

  // ** Deep Merge Component overrides of core and user
  const mergeComponentOverrides = (theme: Theme) => deepmerge({ ...overrides(theme) }, AppThemeOptions()?.components)

  // ** Deep Merge Typography of core and user
  const mergeTypography = (theme: Theme) => deepmerge(typography(theme), AppThemeOptions()?.typography)

  // ** Continue theme creation and pass merged component overrides to CreateTheme function
  theme = createTheme(theme, {
    components: { ...mergeComponentOverrides(theme) },
    typography: { ...mergeTypography(theme) }
  })

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStyles styles={() => GlobalStyling(theme) as any} />
      {children}
    </ThemeProvider>
  )
}

export default ThemeComponent
